import { IsNotEmpty, IsUUID } from 'class-validator';

export class MarkReadDto {
  @IsNotEmpty()
  @IsUUID()
  eventId: string;

  @IsNotEmpty()
  @IsUUID()
  documentId: string;
}
